<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                <van-col span="12"><div class="banner-title">确认信息</div></van-col>
                <van-col span="6">
                </van-col>
            </van-row>
        </div>
        <div class="user-info">
            <div>
                <img class="user-img" :src="user.userAvatar ? user.userAvatar : defaultImg">
            </div>
            <div class="user-name">{{user.userName}}</div>
            <div class="user-phone" v-if="type == 'phone'">{{user.phone}}</div>
            <div class="add-btn" @click="toApply" v-if="!user.status"><span class="add-btn-text">邀请TA</span></div>
            <div class="user-btn" v-if="user.status"><span class="user-btn-text">互为好友</span></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'confirm',
        data() {
            return {
                theme: 'light',
                defaultImg: require('@/assets/share/home/noImg.png'),
                user: {},
                type: '',
            }
        },
        mounted() {
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme
            }
            this.user = JSON.parse(localStorage.getItem("addUser"));
            this.type = this.$route.params.type;
        },
        methods: {
            back() {
                this.$router.back();
            },
            toApply() {
                localStorage.setItem("statusPrivilege", '1');
                localStorage.setItem("ecgPrivilege", '1');
                localStorage.setItem("sportPrivilege", '1');
                localStorage.setItem("sportPrivilege", '1');
                localStorage.setItem("remark", this.user.userName);
                this.$router.push({
                    name: 'applyLight',
                    query: {
                        theme: this.theme
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .user-info {
        text-align: center;
        position: relative;
    }

    .user-img {
        width: 50px;
        height: 50px;
        border: 2px solid var(--text-color-1);
        margin-top: 20px;
        border-radius: 50%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }

    .user-name {
        font-size: 15px;
        padding-top: 82px;
        color: var(--text-color-1);
    }

    .user-phone {
        font-size: 12px;
        color: var(--text-color-1);
        margin-top: 8px;
    }

    .add-btn {
        width: 311px;
        height: 52px;
        border-radius: 13px 13px 13px 13px;
        border: 2px solid #404040;
        margin: 30px auto;
        font-size: 17px;
        line-height: 52px;

    }

    .add-btn-text {
        color: var(--text-color-1);
    }

    .user-btn {
        width: 345px;
        height: 56px;
        background: var(--bg-color-2);
        border-radius: 13px 13px 13px 13px;
        margin: 30px auto;
        font-size: 17px;
        line-height: 56px;
    }

    .user-btn-text {
        color: var(--text-color-2);
    }
</style>



// WEBPACK FOOTER //
// src/views/shareLight/08confirm.vue